import { Stack } from '@mui/material';
import CreditUsage from 'src/features/Activities/MyActivities/CreditUsage';
import CreditUsageLog from 'src/features/Activities/MyActivities/CreditUsageLog';

const MyActivities = () => {
  return (
    <Stack spacing={3}>
      <CreditUsage />
      <CreditUsageLog />
    </Stack>
  );
};

export default MyActivities;
